import React, { Component } from "react";
import { isAfter, isBefore, subDays } from "date-fns";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { parseIsoDate } from "@formant/date-fns/parseIsoDate";
import { Icon } from "@formant/ui/component/common/Icon";

import { organizationStore } from "../stores";
import { Accordion } from "./common/Accordion";
import { FlexSpacer } from "./common/FlexSpacer";
import { IconButton } from "./common/IconButton";
import * as styles from "./TrialBanner.scss";
import { trialBannerDismissedFlag } from "./TrialBannerDismissedFlag";

@observer
export class TrialBanner extends Component {
    @observable
    private dismissed: boolean =
        localStorage.getItem(trialBannerDismissedFlag) === "true";

    public render() {
        const organization = organizationStore.authenticated() || undefined;

        const now = new Date();
        const trialPeriodEnd = organization?.trialPeriodEnd
            ? parseIsoDate(organization.trialPeriodEnd)
            : undefined;

        const trialExpiring =
            !!trialPeriodEnd &&
            isBefore(now, trialPeriodEnd) &&
            isAfter(now, subDays(trialPeriodEnd, 5));

        const trialExpired = !!trialPeriodEnd && isAfter(now, trialPeriodEnd);

        return (
            <Accordion
                className={styles["trial-banner"]}
                visible={
                    !this.dismissed &&
                    (trialExpiring || trialExpired) &&
                    !(organization?.stripeInfo || undefined)?.card
                }
                maxHeight={30}
            >
                <Icon className={styles.icon} name="warning" />
                {trialExpiring && (
                    <div className={styles.message}>
                        Your Formant complimentary period is about to expire.
                    </div>
                )}
                {trialExpired && (
                    <div className={styles.message}>
                        Your Formant complimentary period has expired.
                    </div>
                )}
                <FlexSpacer />
                <IconButton icon="close" onClicked={this.onDismiss} />
            </Accordion>
        );
    }

    private onDismiss = () => {
        localStorage.setItem(trialBannerDismissedFlag, "true");
        this.dismissed = true;
    };
}
